import React from 'react';
import { DateTime } from 'luxon';

import { Icon, Layout, Text } from 'ds';
import { formatDate } from 'shared/time';

import { nextDeliveryDate } from '../utils';

const ConsumablesOnboardingRestockingInfoMessage: React.FC = () => {
  const deliveryDate = nextDeliveryDate();
  const fiveDaysBeforeDeliveryDate = DateTime.fromISO(deliveryDate.toISO()).minus({ days: 5 });

  return (
    <Layout direction="row" gap={8} borderRadius={8} paddingX={8} paddingY={12} color="purple-gradient-transparent">
      <Icon name="info" size="xs" color="purple-gradient" />
      <Text size="body-xs" color="purple-gradient" semibold>
        Start today and get your first delivery on{' '}
        {formatDate({ date: deliveryDate, format: 'MED_WITH_SHORT_WEEKDAY' })}. Modify or cancel this order before{' '}
        {formatDate({ date: fiveDaysBeforeDeliveryDate, format: 'MED_WITH_SHORT_WEEKDAY' })}.
      </Text>
    </Layout>
  );
};

export default ConsumablesOnboardingRestockingInfoMessage;
